import LevelPlayer, { type LevelResult } from './LevelPlayer';
import RacePlayer from './RacePlayer';
import { cleanLevel, levelThumb, type Level } from '../game/levels';
import { cleanRace, isRace, raceThumb, type RaceLevel } from '../game/race';

// A student-made game is either a platformer level or a race course; these
// pick the right player, checker and picture for whichever it is.

export type Game = Level | RaceLevel;

export const cleanGame = (x: unknown): Game | null => (isRace(x) ? cleanRace(x) : cleanLevel(x));
export const gameThumb = (g: Game, maxW: number): string => ('mode' in g && g.mode === 'race' ? raceThumb(g, maxW) : levelThumb(g as Level, maxW));
export const gameIcon = (x: unknown) => (isRace(x) ? '🏎️' : '🕹️');

type Props = { game: Game; look: unknown; title: string; onDone?: (r: LevelResult) => void; onClose: () => void; footer?: React.ReactNode };

export default function GamePlayer({ game, ...rest }: Props) {
  return 'mode' in game && game.mode === 'race' ? <RacePlayer level={game} {...rest} /> : <LevelPlayer level={game as Level} {...rest} />;
}
